import React from 'react';

export default class NavbarLeft extends React.Component {
  render () {
    return <div style={{ display: 'flex' }}>{this.props.children}</div>
  }
}